import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SideDrawer from '../_custom/SideDrawer/SideDrawer';
import { COLORS } from '../../utils/constants/colors';
import { useDispatch } from 'react-redux';
import { setShowManageTeamDrawer } from '../../store/investor/action';
import { setShowManageUserDrawer } from '../../store/company/action';
import { USER_TYPE } from '../ManageDealDrawer/DealDrawerConstants';
import ManageTeam from './components/ManageTeam';

type ManageTeamDrawerProps = {
    selectedOrgName?: string;
    orgId?: string;
    userType?: string;
};

export const ManageTeamDrawer = ({ selectedOrgName, orgId, userType }: ManageTeamDrawerProps) => {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    const handleClose = () => {
        searchParams.delete('category');
        if (userType === USER_TYPE.ASSESSEE) {
            searchParams.delete('page');
            setSearchParams(searchParams);
            dispatch(setShowManageUserDrawer(false));
        } else {
            setSearchParams(searchParams);
            dispatch(setShowManageTeamDrawer(false));
        }
    };

    return (
        <>
            <SideDrawer
                onClose={handleClose}
                style={{
                    backgroundColor: COLORS.LIGHT_GREY_BG,
                    overflowY: 'auto',
                }}
                iconStyle={{ zIndex: 20 }}
                width={'70%'}
            >
                <ManageTeam selectedOrgName={selectedOrgName} orgId={orgId} userType={userType} />
            </SideDrawer>
        </>
    );
};
